import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PageHeading from '~/components/page-heading';
import Button from '~/components/button';
import useTeamMembers from '~/hooks/useTeamMembers';

import MemberCard from './MemberCard';

const TeamListing = () => {
  const { loading, error, members } = useTeamMembers();

  return (
    <>
      <S.TopBar>
        <PageHeading>Team</PageHeading>
        <Button as={Link} to="/team/add">
          Add new member
        </Button>
      </S.TopBar>
      <S.Container>
        {loading || error
          ? null
          : members.map((member) => (
              <S.MemberCard member={member} key={member.email} />
            ))}
      </S.Container>
    </>
  );
};

const S = {
  TopBar: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  Container: styled.div`
    margin: 1.5rem 0;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 1rem;
    }

    @media (min-width: ${({ theme }) => theme.screens.lg}) {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
  MemberCard: styled(MemberCard)`
    width: 100%;
    max-width: 100%;
    margin: 0 0 1rem 0;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      /* width: 50%; */
      margin: 0 1rem 1rem 0;
    }
  `,
};

export default TeamListing;
